import base from './base.repository';

export default {
    ...base,
    loadRestrictedVisitors(clientId, filters, page){
        const params = {...filters, page: page, client: clientId};
        this.get(`restricted-visitors${this.querify(params)}`);
        return this;
    },
    saveRestrictedVisitor(restrictedVisitor) {
        this.post(`restricted-visitors`, restrictedVisitor);
        return this;
    },
    updateRestrictedVisitor(restrictedVisitor, id) {
        this.put('restricted-visitors/' + id, restrictedVisitor);
        return this;
    },
    deleteRestrictedVisitor(id){
        this.delete('restricted-visitors/'+ id);
        return this;
    },
    uploadPhotoRestrictedVisitor(payload){
        this.post(`restricted-visitors/upload-photo`, payload);
        return this;
    }
}